import type { FC } from "react";
import type { IdentificationDocumentListItemResponseDTO } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { PaperworkFormStep } from "web_myplann/Profile/Components/Paperwork/PaperworkFormStep";
import { PaperworkSuccessStep } from "web_myplann/Profile/Components/Paperwork/PaperworkSuccessStep";
import type { PaperworkDocType } from "web_myplann/Profile/Constants/paperworkDocTypes";
import { usePaperworkAddFlow } from "web_myplann/Profile/Hooks/usePaperworkAddFlow";

type Props = {
	type: PaperworkDocType;
	document?: IdentificationDocumentListItemResponseDTO;
};

export const PaperworkAddFlow: FC<Props> = ({ type, document }) => {
	const { t } = useResource();
	const flow = usePaperworkAddFlow(type, document);
	const typeName = t(Resources.Paperwork.Types[type.id]);

	if (flow.step === "form") {
		return (
			<PaperworkFormStep
				type={type}
				typeName={typeName}
				form={flow.documentForm}
				isUpdate={flow.isUpdate}
				onSubmit={flow.submitForm}
				onBack={flow.goBack}
			/>
		);
	}

	return (
		<PaperworkSuccessStep
			typeName={typeName}
			reminderSet={flow.reminderSet}
			mode={flow.isUpdate ? "update" : "create"}
			onViewDocuments={flow.exit}
			onAddAnother={flow.addAnother}
			onBack={flow.goBack}
		/>
	);
};
